export enum RouteKeys {
    List = '/',
    New = '/new',
    Edit = '/:id',
  }
  